export const climateRiskLensTexts = {
  SourceDescription: () => <></>,
  SourceTooltipContent: () => <></>,
  LensTitle: () => <>Climate risk</>,
  LensDescription: () => <>Physical and transition climate risks</>,
  LensTooltipContent: () => <></>,
};
